import React, { useCallback, useEffect } from 'react';
import { Box, Grid, useMediaQuery } from '@material-ui/core';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '../../..';
import SliderAction from '../../actions/SliderAction';
import GuideAction from '../actions/GuideAction';
import { PrompterConfig, ScreenType } from '../../utils';
import { setFontSize } from '../../../../store/modules/studio/actions';
import { selectFontSize } from '../../../../store/modules/studio/selectors';
import { StudioControlStyles } from '../../styles';
import theme from '../../../../theme';
import StudioToolTip from '../../actions/StudioToolTip';

const FontSizeAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const currentFontSize = useSelector(selectFontSize);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const isTablet = useMediaQuery(theme.breakpoints.down('sm'));
  let screenSize = (isTablet) ? ScreenType.Medium : ScreenType.Large;
  screenSize = (isMobile) ? ScreenType.Small : screenSize;

  const smallFontSize = PrompterConfig.fontSize[screenSize].buttonSmallFontSize;
  const mediumFontSize = PrompterConfig.fontSize[screenSize].buttonMediumFontSize;
  const largeFontSize = PrompterConfig.fontSize[screenSize].buttonLargeFontSize;
  const smallFontSizeHandler = useCallback(() => {
    dispatch(setFontSize(smallFontSize));
  }, [dispatch, smallFontSize]);


  const mediumFontSizeHandler = useCallback(() => {
    dispatch(setFontSize(mediumFontSize));
  }, [dispatch, mediumFontSize]);


  const LargeFontSizeHandler = useCallback(() => {
    dispatch(setFontSize(largeFontSize));
  }, [dispatch, largeFontSize]);

  const onChange = useCallback((e: React.ChangeEvent<{}>, size: number | number[]) => {
    if (e.type === 'keydown') {
      return;
    }
    if (!Array.isArray(size)) {
      dispatch(setFontSize(size));
    }
  }, [dispatch]);

  const setFontSizeOnResize = useCallback(() => {
    if (isTablet && currentFontSize > largeFontSize) {
      dispatch(setFontSize(largeFontSize));
    }
    if (isMobile && currentFontSize > largeFontSize) {
      dispatch(setFontSize(largeFontSize));
    }

    if (!isMobile && !isTablet && currentFontSize < smallFontSize) {
      dispatch(setFontSize(smallFontSize));
    }
  }, [isMobile, isTablet, currentFontSize, dispatch, smallFontSize, largeFontSize]);

  useEffect(() => {
    setFontSizeOnResize();
  }, [setFontSizeOnResize]);

  return (
    <Grid container style={{ paddingTop: 0 }} item xs={12}>
      <GuideAction />
      <Grid item>
        <Grid item style={{ marginTop: 16 }}>
          <p className={classes.label}>Font Size</p>
          <Box className={classes.fontSizeButtonsWrapper}>
            <StudioToolTip title="Small font size">
              <div className={classes.fontSizeButtonWrapper}>
                <Button
                  className={
                    clsx(
                      classes.button, classes.fontSizeButton,
                      currentFontSize === smallFontSize ? classes.activeButton : '',
                    )
                  }
                  onClick={smallFontSizeHandler}
                  data-intercom-target="Button: S"
                >
                  S
                </Button>
              </div>
            </StudioToolTip>
            <StudioToolTip title="Medium font size">
              <div className={classes.fontSizeButtonWrapper}>
                <Button
                  className={
                    clsx(
                      classes.button, classes.fontSizeButton,
                      currentFontSize === mediumFontSize ? classes.activeButton : '',
                    )
                  }
                  onClick={mediumFontSizeHandler}
                  data-intercom-target="Button: M"
                >
                  M
                </Button>
              </div>
            </StudioToolTip>
            <StudioToolTip title="Large font size">
              <div className={classes.fontSizeButtonWrapper}>
                <Button
                  className={
                    clsx(
                      classes.button, classes.fontSizeButton,
                      currentFontSize === largeFontSize ? classes.activeButton : '',
                    )
                  }
                  onClick={LargeFontSizeHandler}
                  data-intercom-target="Button: L"
                >
                  L
                </Button>
              </div>
            </StudioToolTip>
            <div className={classes.slider}>
              <SliderAction
                style={{ marginTop: 14 }}
                value={currentFontSize}
                onChange={onChange}
                step={PrompterConfig.fontSizeDelta}
                min={smallFontSize}
                max={largeFontSize}
                valueLabelDisplay="auto"
              />
            </div>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FontSizeAction;
